module.exports = __webpack_public_path__ + "static/vinnies_logo-382fe8dafcef5c3f7fbee8f034a3cfe6.png";